const en = {
	Местоположение: 'Location',
	'Введите регион': 'Select region',
	ВБР: 'Fish name',
	'Не выбрано': 'Not selected',
	'Вид разделки': 'Type of cutting',
	Изготовитель: 'Manufacturer',
	'Введите изготовителя': 'Select manufacturer',
	'Масса нетто, кг': 'Net weight, kg',
	Найти: 'Find',
	'Район промысла': 'Fishery Region',
	'Выберите район': 'Select region',
	'Дата изготовления': 'Date of processing',
	'Выберите дату': 'Select date',
	'Вид тары': 'Type of packaging',
	'Выберите вид': 'Select type',
	'Вес 1 места': 'Weight of 1 unit',
	'Укажите вес': 'Select weight',
	'Экспортируется в страну': 'Exported to country',
	'Укажите страну': 'Select country',
	'Глубокая переработка': 'Deep processing',
	'Укажите вид': 'Select type',
	Применить: 'Apply',
	'Очистить фильтры': 'Clear filters',
	'Купить рыбу и морепродукты': 'Buy fish and seafood',
	Фильтры: 'Filters',
	'Найти рыбный склад': 'Find a refrigerated warehouse',
	'Поиск рыбы доступен после регистрации.':
		'Fish search is available after registration and tariff selection.',
	'Вся рыба тут! @fishplacesales': 'The whole fish is here! @fishplacesales',
};

export default en;
